import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-setting',
  templateUrl: './menu-setting.component.html',
  styleUrls: ['./menu-setting.component.scss']
})
export class MenuSettingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
